module.exports = __webpack_public_path__ + "static/media/favicon.4949bd94.ico";